import UNVERIFIED_COMPANY_RULES from "~/constants/companyVerification/UNVERIFIED_COMPANY_RULES";
import Alert from "~/ui/Alert";
import InputHelpText from "~/ui/InputHelpText";

const UNVERIFIED_WARNINGS = Object.freeze({
  customerCanNotBook: (
    <InputHelpText>
      Företaget är inte verifierat och kan därmed inte ännu ta emot bokningar
    </InputHelpText>
  ),
  maxBookingsWarning: (
    <Alert type="warning">
      Ett overifierat företag kan manuellt skapa max{" "}
      {UNVERIFIED_COMPANY_RULES.maxBookings} bokningar, där SMS och mejl inte
      skickas ut till kunden.
    </Alert>
  ),
  noSMSWarning: (
    <Alert type="warning">
      <p>
        Eftersom ditt företag ej är verifierat kommer inga mejl eller SMS att
        kunna skickas.
      </p>
    </Alert>
  ),
  noSMSNorPublicBookings: (
    <Alert type="warning">
      <p>
        Eftersom ditt företag ej är verifierat kommer inga mejl eller SMS att
        kunna skickas. Användare kommer heller inte kunna boka hos dig via
        Bokahundtrim förrän ditt företag är verifierat.
      </p>
    </Alert>
  ),
  constraints: (
    <Alert subtle type="warning">
      <div className="text-md leading-7">
        <p>
          Eftersom ditt konto ej är verifierat:
          <ul className="list-disc pl-6">
            <li>Kommer inga mejl eller SMS skickas ut till kunder</li>
            <li>Kan inga kunder se eller boka hos ditt företag</li>
            <li>
              Kan ditt företag endast skapa som max{" "}
              {UNVERIFIED_COMPANY_RULES.maxBookings} bokningar
            </li>
            <li>Debiteras du inte.</li>
          </ul>
        </p>
      </div>
    </Alert>
  ),
});

export default UNVERIFIED_WARNINGS;
